import React, { Component } from 'react';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

class AddCustomerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalContent: {
        _id: undefined,
        customerName: '',
        email: '',
        phoneNumber: '',
        address: ''
      }
    }
  }

  componentDidMount() {
    this.setState({modalContent: this.props.modalContent})
  }

  onModalChange = (modalKey, value) => {
    let content = this.state.modalContent;
    content[modalKey] = value;
    this.setState({
      modalContent: content
    })
  }

  onSubmitClick = () => {
    const { customerName, email, phoneNumber, address } = this.state.modalContent;

    if ( this.state.modalContent._id ) {
      fetch(`${global.gConfig.backend.url}/api/v1/customer/${this.state.modalContent._id}`, {
        method: 'put',
        headers: {'Content-type': 'application/json'},
        body: JSON.stringify({
          customerName: customerName,
          email: email,
          phoneNumber: phoneNumber,
          address: address
        })
      })
        .then( res => res.json())
        .then( result => {
          if ( result ) {
            this.props.afterPutCustomer(result);
            this.props.toggle();
          }
        })
        .catch( err => {console.log(err)})
    } else {
      fetch(`${global.gConfig.backend.url}/api/v1/customer`, {
        method: 'post',
        headers: {'Content-type': 'application/json'},
        body: JSON.stringify({
          customerName: customerName,
          email: email,
          phoneNumber: phoneNumber,
          address: address
        })
      })
        .then( res => res.json())
        .then( result => {
          if ( result ) {
            this.props.afterPostCustomer(result);
            this.props.toggle();
          }
        })
        .catch( err => {console.log(err)})
    }
  }

  render() {
    const { modal, toggle } = this.props;
    const { modalContent } = this.state;

    return (
      <MDBContainer fluid>
        <MDBModal isOpen={modal} toggle={toggle}>
          <MDBModalHeader toggle={toggle}>{modalContent._id ? "Modify Customer" : "New Customer"}</MDBModalHeader>
          <MDBModalBody>
            <div className="form-group">
              <label htmlFor="formGroupExampleInput">Name</label>
              <input
                type="text"
                onChange={(e) => {this.onModalChange( "customerName", e.target.value )}}
                value={modalContent.customerName}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="formGroupExampleInput">Email</label>
              <input
                type="text"
                onChange={(e) => {this.onModalChange( "email", e.target.value )}}
                value={modalContent.email}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="formGroupExampleInput">Phone Number</label>
              <input
                type="text"
                onChange={(e) => {this.onModalChange( "phoneNumber", e.target.value )}}
                value={modalContent.phoneNumber}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="formGroupExampleInput">Shipping Address</label>
              <input
                type="text"
                onChange={(e) => {this.onModalChange( "address", e.target.value )}}
                value={modalContent.address}
                className="form-control"
              />
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={toggle}>Close</MDBBtn>
            <MDBBtn color="primary" onClick={this.onSubmitClick}>Save changes</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default AddCustomerModal;
